module.exports = __webpack_public_path__ + "static/media/LogicWheel1_5_2.ccdb7531.png";